/**
 * Centralized localStorage keys for the application
 * All localStorage keys should be defined here to avoid hardcoding
 */

export const ACTIVE_TENANT_STORAGE_KEY = 'activeTenant';
export const APP_STATE_STORAGE_KEY = 'appState';
export const VISA_APPLICATION_COLUMN_VISIBILITY_KEY = 'visaApplicationColumnVisibility';
